define.alias("ember-composable-helpers/helpers/entries", "media/helpers/entries");